// extracted by mini-css-extract-plugin
export default {"bg":"Register_bg__YSJDU","h":"Register_h__m4nvG"};